// @flow strict

import React, { type Node, Fragment } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * Xing icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const XingIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <Fragment>
      <defs>
        <path id="xing__a" d="M0 0.038L7.67 0.038 7.67 10.758 0 10.758z" />
        <path
          id="xing__c"
          d="M0.001 0.035L11.503 0.035 11.503 21.546 0.001 21.546z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H35V35H0z" />
        <g>
          <g transform="translate(8 8) translate(0 4.275)">
            <mask id="xing__b" fill="#fff">
              <use xlinkHref="#xing__a" />
            </mask>
            <path
              className="xing"
              fill={color}
              d="M5.563.617c-.223-.386-.505-.58-.848-.58h-3.07c-.197 0-.334.065-.412.194-.094.128-.09.287.013.476l2.069 3.59c.008.01.008.013 0 .013l-3.25 5.766c-.086.163-.086.318 0 .463.085.146.218.22.398.22h3.07c.326 0 .604-.198.835-.593C6.484 6.41 7.585 4.452 7.67 4.298L5.563.617z"
              mask="url(#xing__b)"
            />
          </g>
          <g transform="translate(8 8) translate(7.695)">
            <mask id="xing__d" fill="#fff">
              <use xlinkHref="#xing__c" />
            </mask>
            <path
              className="xing"
              fill={color}
              d="M11.43.711c.097-.182.097-.342 0-.48-.08-.13-.215-.196-.408-.196H7.845C7.502.035 7.22.23 7 .62l-7 12.251 4.47 8.09c.21.39.5.585.869.585h3.15c.194 0 .334-.065.422-.195.088-.148.084-.308-.013-.481L4.47 12.87v-.013L11.43.711z"
              mask="url(#xing__d)"
            />
          </g>
        </g>
      </g>
    </Fragment>
  );
};
